import { Chip } from '@material-ui/core'
import styled, { css } from 'styled-components'

interface OnlineTagProps {
    isOnline?: boolean
}

export const OnlineTag = styled(Chip).withConfig({
    shouldForwardProp: (prop) => String(prop) !== 'isOnline',
})<OnlineTagProps>`
    ${({ isOnline }) =>
        isOnline &&
        css`
            background-color: #4caf50;
            color: #fff;
        `}
`
